import { CommonEnums } from 'dashboard-services/api/common';
import { DataLakeEnums, DataLakeQuery } from 'dashboard-services/api/dataLake';
import { CommonService } from 'dashboard-services/services';

import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export default(() => {
  const useSearchGroups = ({ query, provider, groupName, tags, shouldBeLimited, getQueryBuilder, size = CommonService.getRequestSize(), shouldRefetch = true, enabled = true, onSelect, fullQuery, ...rest }) =>
    useInfiniteQuery({
      ...DataLakeQuery.QUERIES.searchGroups(
        getQueryBuilder,
        {
          query: fullQuery ? fullQuery : (groupName ? `name.keyword=${groupName}` : (query ? `name=*${String(query).toLowerCase()}*` : undefined)),
          size,
          sortBy: DataLakeEnums.GROUPS_SORT_BY.NAME,
          sortOrder: CommonEnums.SORT_ORDER.ASCENDING,
          provider,
          groupTags: tags ? tags?.split(",") : undefined,
        }
      ),
      initialPageParam: 0,
      refetchInterval: () => !shouldRefetch || shouldBeLimited(provider) ? undefined : 10000,
      getNextPageParam: lastPage => lastPage.totalSize > lastPage.from + (lastPage.items || []).length ? lastPage.from + (lastPage.items || []).length : undefined,
      enabled,
      select: onSelect,
      ...rest
    })

  const useCreateGroup = ({ description, fields, getQueryBuilder, groupTags, name, onSuccess, ...rest }) => {
    const queryClient = useQueryClient()
    return useMutation({
      ...DataLakeQuery.QUERIES.createGroup(
        getQueryBuilder,
        {
          name: name ? String(name)?.trim() : name,
          description,
          fields,
          groupTags
        }
      ),
      onSuccess: response => {
        queryClient.invalidateQueries({ queryKey: DataLakeQuery.KEYS.SEARCH_GROUPS() }, { queryKey: DataLakeQuery.KEYS.GET_GROUP() })
        onSuccess?.(response)
      },
      ...rest
    })
  }

  return {
    useSearchGroups,
    useCreateGroup
  }
})()